import { render, staticRenderFns } from "./Cooperation.vue?vue&type=template&id=752b9bae&scoped=true&"
import script from "./Cooperation.vue?vue&type=script&lang=js&"
export * from "./Cooperation.vue?vue&type=script&lang=js&"
import style0 from "./Cooperation.vue?vue&type=style&index=0&id=752b9bae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752b9bae",
  null
  
)

component.options.__file = "Cooperation.vue"
export default component.exports